module.exports = __webpack_public_path__ + "img/laravel.e1b53fb5.svg";